<template>
  <div class="privacy">
    <h2>隐私政策</h2>
    <h5>生效日期：2021年11月1日</h5>
    <h5>
      如果您有任何疑问、意见或建议，请通过本政策第八条的联系方式与我们联系。
    </h5>
    <p>
      北京丘比食品有限公司（以下称“我们”）深刻理解个人信息是您的一项重要权利，个人信息的管理和保护是我们的社会责任之一，我们会尽全力保护您个人信息的安全可靠。我们致力于维护您对我们的信任，遵循合法、正当、必要和诚信的原则，收集和使用您的个人信息。同时，我们将采取相应的安全保护措施来保护您的个人信息。
    </p>
    <p>
      请在使用我们的产品或服务前，仔细阅读并了解本《隐私政策》（以下称“本政策”）（特别是加粗加划线的部分）。您使用或在我们更新本政策后（我们会及时提示您更新的情况）继续使用我们的产品及服务，即意味着您已完全理解并同意本政策(含更新版本)内容，并且同意我们按照本政策收集、存储、使用、加工、传输、提供、公开、删除（以下称“处理”）您的相关信息。
    </p>
    <h5>本政策将帮助您了解以下内容：</h5>
    <p>一、适用范围</p>
    <p>二、我们收集哪些您的个人信息并将如何使用您的个人信息</p>
    <p>三、我们如何共享、转让、公开披露、保存您的个人信息</p>
    <p>四、我们如何保护您的个人信息</p>
    <p>五、您的权利</p>
    <p>六、我们如何处理未成年人的个人信息</p>
    <p>七、本政策如何更新</p>
    <p>八、如何联系我们</p>
    <h5>一、适用范围</h5>
    <p>1、我们通过本微信公众号（丘比食品）提供的产品和服务均适用本政策。</p>
    <p>
      2、您使用第三方（例如天猫、京东等）向您提供产品及服务时，希望您能阅读并了解该第三方适用的隐私政策，由于我们并未获取或收集您的个人信息，因此并不适用本政策的有关规定，我们也不承担可能由第三方引发的相关责任。
    </p>
    <h5>二、我们收集哪些您的个人信息并将如何使用您的个人信息</h5>
    <p>（一）所收集的个人信息的内容以及使用目的</p>
    <p>
      个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
    </p>
    <p>当您在访问本微信公众号的以下页面时，将涉及向我们提供您的个人信息。</p>
    <p>
      （1）当您访问本微信公众号内的丘比粉丝俱乐部（Fun
      Club）时，表示您已自愿同意向我们提供您的以下个人信息（以下称“初步个人信息”）。但以下信息不符合上述被认定为个人信息的法定要件时，将不被作为个人信息处理且不适用本政策的各项规定：
    </p>
    <p>1）您的微信头像</p>
    <p>2）您的微信用户名</p>
    <p>
      上述初步个人信息是您加入丘比粉丝俱乐部、享受粉丝权益、浏览粉丝俱乐部时所需的“最低必要信息”。
    </p>
    <p>
      您仍有权拒绝提供上述您的初步个人信息或撤回就我们处理您的个人信息的同意，但此时您将无法访问丘比粉丝俱乐部（Fun
      Club），对此请您理解。
    </p>
    <p>
      我们收集并处理您的上述个人信息的目的是：用于实施我们对于访问丘比粉丝俱乐部人群的分析、统计和管理，以提升服务质量进而提升客户满意度。
    </p>
    <p>
      （2）当您通过点击“丘比粉丝俱乐部”中的“我”-“完善个人资料得140积分”并填写个人资料时，表示您同意自愿向我们提供您的以下个人信息（以下称“附加个人信息”）
    </p>
    <p>1）真实姓名 *</p>
    <p>2）性别</p>
    <p>3）手机号码 *</p>
    <p>4）所在省市区 *</p>
    <p>5）邮寄地址 *</p>
    <p>6）邮箱 （ * 6）-8）可择一提供）</p>
    <p>7）qq号 （ * 6）-8）可择一提供）</p>
    <p>8）微信号 （ * 6）-8）可择一提供）</p>
    <p>您同意我们将您的附加个人信息用于以下目的：</p>
    <p>
      1）用于我们进一步实施对于访问丘比粉丝俱乐部人群的分析、统计和管理，以提升服务质量进而提升客户满意度；
    </p>
    <p>
      2）当您满足积分兑换奖励条件时，向您寄送相关奖品并为此与您取得必要的联系，进行确认；
    </p>
    <p>
      3）我们将为您提供产品及服务相关的最新信息及资料（包括有关展示会、学习会和促销活动的信息或相关产品的样品等）及商业广告
    </p>
    <p>
      在提供附加个人信息时，您仍有权拒绝提供或撤回您已经提供的上述信息，或有关对于我们处理您个人信息的同意。但当您拒绝提供标注*符号的个人信息时，您将无法获得我们提供的140积分。同时，我们也将无法向您提供前述“寄送相关奖品”以及“提供最新信息及资料”的服务。由于您提供的附加个人信息不准确或存在错误，也将可能造成我们无法向您提供上述产品和服务。对此，我们将无需承担相应责任。
    </p>
    <p>
      需要您提供的信息可能会基于活动开展的需要作出增减和调整，具体需要您提供的信息，以系统或专业人员向您索取的个人信息内容为准。
    </p>
    <p>
      （二）根据相关规定，以下情形（以下称“例外情形”）中，我们收集、使用您的个人信息无需征得您的授权同意：
    </p>
    <p>
      1.为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
    </p>
    <p>2.为履行法定职责或者法定义务所必需；</p>
    <p>
      3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
    </p>
    <p>
      4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
    </p>
    <p>
      5.依照《中华人民共和国个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
    </p>
    <p>6.法律、行政法规规定的其他情形。</p>
    <p>（三）我们如何使用您的个人信息</p>

    <p>
      1.
      我们会根据本政策并为实现我们的产品或服务功能对所收集的个人信息进行使用。
    </p>

    <p>
      2.
      除非您联系我们删除或拒绝我们收集、使用，否则我们将在您使用我们的产品或服务期间持续收集并使用您所提供的个人信息。在您联系我们予以删除时，我们将停止使用并删除您的个人信息。
    </p>

    <p>3. 您的个人信息将存储于中华人民共和国境内。</p>

    <p>
      4.
      当我们要将信息用于本政策未载明的其它用途或目的时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。在征求您的同意时，我们可能会通过电话、短信、微信、邮件等方式与您取得联系。
    </p>
    <p>三、我们如何共享、转移、公开披露、保存您的个人信息</p>
    <p>（一）共享</p>
    <p>
      我们不会在未经您的同意或授权的情况下向其他公司、组织和个人分享您的个人信息，但以下情况除外：
    </p>
    <p>
      1.
      在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
    </p>
    <p>
      2.
      我们可能会根据法律法规规定，或按行政机关、司法机关的强制性要求，对外共享您的个人信息。
    </p>
    <p>
      3.
      与授权合作伙伴共享：基于相关法律法规的规定，匿名化处理后的信息不属于个人信息。因此，我们可能会在实施匿名化处理后，将该信息提供给以下合作伙伴：
    </p>
    <p>
      1）
      广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总及匿名化处理，以便它不会识别您个人。
    </p>
    <p>
      2）
      供应商、服务提供商、销售代理商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括联合促销企划的实施，提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
    </p>
    <p>
      即使该等信息不属于个人信息，但我们与之共享信息的公司、组织和个人，我们仍会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。
    </p>
    <p>
      作为例外，由于本公众号将委托以下受托人（以下称“受托人”）制作并维护。因此，您在本公众号中所提供的个人信息，将由我公司委托受托人进行信息处理、保存和管理。您需要同意由受托人处理您的个人信息。
    </p>
    <p>受托人的详细信息如下：</p>
    <p>公司名称：大广（中国）广告有限公司北京分公司</p>
    <p>联系方式：010-65880255</p>
    <p>处理目的：辅助我公司实现本规则第二条中的“所收集的个人信息的使用目的”</p>
    <p>
      处理方式：对于个人信息进行收集、存储，应北京丘比食品有限公司的要求向其进行提供
    </p>
    <p>个人信息的种类： 您所提供的初步个人信息及附加个人信息</p>
    <p>（二）转移</p>
    <p>我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：</p>
    <p>
      1.
      在获取明确同意的情况下转移：获得您的明确同意后，我们会向其他方转移您的个人信息；
    </p>
    <p>
      2.
      我们因合并、分立、解散、被宣告破产等原因需要转移个人信息的，将在向您告知接收方的名称或者姓名和联系方式，且接收方将继续履行个人信息处理者的义务的前提下，转移您的个人信息。
    </p>
    <p>3. 存在本隐私政策第二（二）中规定的例外情形的。</p>

    <p>（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p>1. 获得您明确同意后；</p>
    <p>2. 存在本隐私政策第二（二）中规定的例外情形的。</p>

    <p>（四）保存</p>
    <p>
      除法律、行政法规另有规定外，我们所收集的您的个人信息的保存期限为实现处理目的所必要的最短时间。除法律法规对于个人信息的保存的最短期限设定了强制性规定的情形外，如您并未要求我们删除您的个人信息，我们对于收集的您的个人信息的保存期限将不超过“已实现、无法实现或者为实现处理目的不再必要”或“停止提供产品或者服务”（两者以较晚的日期为准）后的
      1 个月。
    </p>

    <p>四、我们如何保护您的个人信息</p>
    <p>
      我们将按照《中华人民共和国个人信息保护法》等相关法律法规、标准的要求，保护您的个人信息。
    </p>

    <p>
      (一）我们将根据个人信息的处理目的、处理方式、个人信息的种类以及对个人权益的影响、可能存在的安全风险等，采取下列措施确保个人信息处理活动符合法律、行政法规的规定，并防止未经授权的访问以及个人信息泄露、篡改、丢失：
    </p>
    <p>1.制定内部管理制度和操作规程；</p>
    <p>2.对个人信息实行分类管理；</p>
    <p>3.采取相应的加密、去标识化等安全技术措施；</p>
    <p>
      4.合理确定个人信息处理的操作权限，并定期对从业人员进行安全教育和培训；
    </p>
    <p>5.制定并组织实施个人信息安全事件应急预案；</p>
    <p>6.法律、行政法规规定的其他措施。</p>
    <p>
      （二）当我们处理个人信息达到国家网信部门规定数量时，我们将指定个人信息保护负责人，负责对个人信息处理活动以及采取的保护措施等进行监督，并且我们将公开个人信息保护负责人的联系方式。此外，我们还会将个人信息保护负责人的姓名、联系方式等报送履行个人信息保护职责的部门。
    </p>

    <p>
      （三）在不幸发生或可能发生个人信息安全事件（包括个人信息的泄露、篡改、丢失）后，我们将会立即采取补救措施，并且将以邮件、信函、电话、推送通知等方式通知您以下事项。但如果我们采取措施能够有效避免信息泄露、篡改、丢失造成危害的，可以不向您进行通知。
    </p>
    <p>
      1.发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害；
    </p>
    <p>2.我们所采取的补救措施和您可以采取的减轻危害的措施；</p>
    <p>3.我们的联系方式。</p>
    <p>此外，我们还会依法向个人信息保护职责的部门进行报告。</p>

    <p>五、您的权利</p>
    <p>我们按照中国相关的法律、法规，保障您对自己的个人信息行使以下权利：</p>
    <p>（一）查阅和复制您的个人信息</p>
    <p>
      您对您的个人信息的处理享有知情权、决定权。您有权查阅、复制您的个人信息。如果您想查阅、复制您的个人信息，可以通过丘比官方平台查看或修改：
    </p>
    <p>如果您无法方法访问和修改这些个人信息，您可以采用以下方式：</p>

    <p>1：通过微信底部菜单栏 “爱在丘比-联系我们”与我们联系。</p>
    <p>2：按照本政策第八条记载的方法联系我们。</p>

    <p>（二）更正和补充您的个人信息</p>
    <p>
      您对您的个人信息的处理享有更正权。您有权更正、补充您的个人信息。如果您想更正、补充您的个人信息，可以通过丘比官方平台进行更正或补充：
    </p>
    <p>如果您无法方法访问和修改这些个人信息，您可以采用以下方式：</p>

    <p>
      1：通过微信底部菜单栏“爱在丘比-联系我们”与我们联系。2：按照本政策第八条记载的方法联系我们。
    </p>
    <p>我们将对其个人信息予以核实，并及时更正、补充。</p>

    <p>（三）删除您的个人信息</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>1.处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
    <p>2.个人信息处理者停止提供产品或者服务，或者保存期限已届满；</p>
    <p>3.个人撤回同意；</p>
    <p>4.个人信息处理者违反法律、行政法规或者违反约定处理个人信息；</p>
    <p>5.法律、行政法规规定的其他情形。</p>
    <p>
      当您或我们协助您删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息，且我们将会停止除存储和采取必要的安全保护措施之外的处理。
    </p>

    <p>（四）撤回同意或改变授权同意的范围</p>
    <p>
      您有权撤回对于个人信息处理的同意，也可以改变您授权同意的范围。但每个业务功能必需基于一些基本的个人信息才能得以完成（见本政策第二条的有关规定），如果您撤回同意或改变授权范围，您可能无法继续享受我们为您提供的产品或服务。
    </p>
    <p>您可以按照本政策第八条记载的方法联系我们撤回同意或改变您的授权范围。</p>
    <p>
      当您撤回同意或因改变授权范围造成我们无法再继续为您提供产品或服务，我们将不再处理相应的个人信息。但撤回同意或因改变授权范围的情况，将不会影响撤回或变更前我们基于个人同意已进行的个人信息处理活动的效力。
    </p>

    <p>（五）注销您的账户</p>
    <p>
      您随时可注销此前在丘比官方平台注册的账户，您可以自行在网上操作或者按照本政策第八条记载的方法联系我们注销。
    </p>
    <p>
      在注销账户之后，我们将停止为您提供产品或服务，并依据第五条第（三）部分的内容删除相应的信息。法律法规另有规定的除外。
    </p>

    <p>(六）选择不针对个人特征的自动化决策</p>
    <p>
      您如果不希望我们通过自动化决策方式向您进行信息推送、商业营销，您可以随时要求我们提供不针对其个人特征进行信息推送、商业营销。您可以采用以下方式与我们取得联系：
    </p>

    <p>1：通过微信底部菜单栏 “爱在丘比-联系我们”与我们联系。</p>
    <p>2：按照本政策第八条记载的方法联系我们。</p>

    <p>（七）要求就处理规则进行解释</p>
    <p>
      您有权要求我们对于包括本隐私政策在内的个人信息处理规则以及自动化决策方式进行解释说明。您可以采用以下方式与我们取得联系：
    </p>
    <p>1： 通过微信底部菜单栏“爱在丘比-联系我们”与我们联系。</p>
    <p>2：按照本政策第八条记载的方法联系我们。</p>

    <p>（八）响应您的上述请求</p>
    <p>
      为保障账号安全，您可能需要提供书面请求，我们也可能会先要求您证明自己的身份，在验证无误后再处理您的请求。
    </p>
    <p>
      我们将在【30】天内做出答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段且高于法律法规强制性标准（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    </p>
    <p>六、我们如何处理未成年人的个人信息</p>
    <p>
      如您是未满14周岁的未成年人，在使用我们的产品与服务，向我们提供个人信息之前，应事先取得您的父母或其他监护人的同意，并由您的监护人在仔细阅读本政策的基础上帮助您完成信息录入流程。对于经监护人同意而收集未成年人个人信息的，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
    </p>
    <p>
      我们将根据《中华人民共和国个人信息保护法》、《儿童个人信息网络保护规定》等相关法律法规的相关规定，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则存储使用、披露您的个人信息，我们会指定专人负责儿童个人信息保护事宜，您或您的监护人可通过微信底部菜单栏“爱在丘比-联系我们”与我们联系。
    </p>

    <p>七、本政策如何更新</p>
    <p>
      我们有权随时更新或修改本政策，我们会在本页面上发布对本政策所做的任何变更。
    </p>
    <p>
      若您不同意本政策及修改后的隐私政策，您应立即停止使用我们的产品或服务。如果您继续使用我们的产品或服务，则视为您同意本政策的内容并接受我们对本政策相关条款所做的修改。
    </p>

    <p>八、如何联系我们</p>
    <p>如果您对本政策有任何疑问、意见或建议，请通过以下方式与我们进行联系：</p>
    <p>名称：北京丘比食品有限公司</p>
    <p>电话：400-810-2001</p>
    <p>
      其他联系方式：您亦可通过丘比官方网站主页上(http://kewpie.com.cn/bj/)的“咨询我们”与我们联系。
    </p>
  </div>
</template>
<script>
export default {
  name: "Privacy",
  components: {},
  props: {
    // props: {
    //   type: String
    // }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
.privacy {
  padding: 20px;
  background: #fff;
}
.privacy h2 {
  margin-bottom: 10px;
  text-align: center;
}
.privacy p {
  text-indent: 2em;
  font-size: 14px;
  color: #707070;
}
</style>